import { defineComponent as n, createBlock as r, openBlock as p, unref as l, mergeProps as m, withCtx as c, createElementVNode as a } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const u = /* @__PURE__ */ n({
  name: "IconShare",
  __name: "IconShare",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (v, e) => (p(), r(l(s), m(o, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        a("path", { d: "m12.75 4.707 1.22 1.22a.75.75 0 1 0 1.06-1.06L12.884 2.72a1.25 1.25 0 0 0-1.768 0L8.97 4.866a.75.75 0 0 0 1.06 1.06l1.22-1.219v9.69a.75.75 0 0 0 1.5 0v-9.69" }, null, -1),
        a("path", { d: "M7 9.646a.75.75 0 0 0-.75.75v9A.75.75 0 0 0 7 20.146h10a.75.75 0 0 0 .75-.75v-9A.75.75 0 0 0 17 9.646h-2a.75.75 0 0 1 0-1.5h2a2.25 2.25 0 0 1 2.25 2.25v9a2.25 2.25 0 0 1-2.25 2.25H7a2.25 2.25 0 0 1-2.25-2.25v-9A2.25 2.25 0 0 1 7 8.146h2a.75.75 0 0 1 0 1.5H7" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
